// extracted by mini-css-extract-plugin
export var borderRadius = "_4i-4";
export var large = "_4i-3";
export var logoContainer = "_4i-0";
export var nameLogo = "_4i-2";
export var small = "_4i-1";